var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightRoundWhiteBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1087048"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7386",
    x: 0.75,
    y: 0.375,
    width: 18.25,
    height: 18.25,
    rx: 9.125,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 370",
    d: "M8.49902 5.99023L12.0086 9.49985L8.49902 13.0095",
    stroke: "#1D4650",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightRoundWhiteBg);
export default __webpack_public_path__ + "static/media/arrow-right-round-white-bg.77ffae747e89d44b66d6073a559cfe22.svg";
export { ForwardRef as ReactComponent };